import React, { useEffect, useState } from 'react';
import { API_KEY, API_URL } from "./Config";
import Loader from "./loader";
import GoodList from "./GoodList";
import Cart from "./Cart";
import BackList from "./BackList";
import {toast} from "react-toastify";

const Shop = (props) => {

    const [goods, setGoods] = useState([]);
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState([]);
    const [showBacked, setShowBacked] = useState(false)

    const addToBacked = (item) => {
        const itemIndex = order.findIndex(orderItem => orderItem.id === item.id)

        if(itemIndex < 0){
            const newItem = {
                ...item,
                quantity: 1
            }
            setOrder([...order,newItem])
          }else{
            const newOrder = order.map((orderItem, index) => {
                if(index === itemIndex) {
                   return {
                       ...orderItem,
                       quantity: orderItem.quantity + 1
                   }
                }else{
                    return item
                }
            });
            setOrder(newOrder)
         }
        toast.success('Goods added to basked succesfully!')
        }
        const handlBasjedShow = () => {
        setShowBacked(!showBacked)
        }
        const removeBacked = (itemId) => {
        const newOrder = order.filter(item => item.id !== itemId)
            setOrder(newOrder)
            toast.error('Goods deleted from basked')
        }
        const incrementQuantity = (itemId) => {
            const newOrder = order.map(el => {
                if(el.id === itemId){
                    const newQuantity = el.quantity + 1
                    return{
                        ...el,
                        quantity: newQuantity
                    }
                }else{
                    return el
                }
            })
            setOrder(newOrder)
        }
        const decrQuantity = (itemId) => {
         const newOrder = order.map(el => {
             if(el.id === itemId){
                 const newQuantity = el.quantity - 1;
                 return{
                     ...el,
                     quantity: newQuantity >= 0 ? newQuantity : 0
                 }
             }else{
                 return el
             }
         })
            setOrder(newOrder)
        }
    useEffect(() => {
        fetch(API_URL, {
            headers: {
                Authorization: API_KEY,
            },
        }).then((response) => response.json())
            .then((data) => {
                data.featured && setGoods(data.featured);
                setLoading(false);
            })
    }, [])

    return (
        <div className="container content">
            <Cart quantity={order.length} handlBasjedShow={handlBasjedShow} />
            {loading ? <Loader /> : <GoodList goods={goods} addToBacked={addToBacked} />}
            {showBacked && <BackList
                order={order}
                handlBasjedShow={handlBasjedShow}
                removeBacked={removeBacked}
                incrementQuantity={incrementQuantity}
                decrQuantity={decrQuantity}
            />}
        </div>
    );
}

export default Shop;